<template>
  <full-container>
    <div slot="header">
      <el-input v-model="queryParams.keyWord" clearable placeholder="关键字查询" size="small" style="width: 240px">
        <template slot="append">
          <el-button icon="el-icon-search" @click="onSearch()" />
        </template>
      </el-input>
    </div>
    <el-table :data="datalist.Items" height="100%">
      <el-table-column type="expand">
        <el-descriptions column="2" slot-scope="{ row }" style="margin-left: 50px">
          <el-descriptions-item label="库存数量">{{ row.Authorizes.Product_Stock ? '允许查看' : '不允许查看' }}</el-descriptions-item>
          <el-descriptions-item label="耗材价格">{{ row.Authorizes.Product_Material ? '允许查看' : '不允许查看' }}</el-descriptions-item>
          <el-descriptions-item label="订购申请限制">{{ row.Authorizes.Product_Purchase ? (row.Authorizes.Product_Purchase == 'ALL' ? '查看全部' : '指定部门') : '仅限本人' }}</el-descriptions-item>
          <el-descriptions-item label="销售申请限制">{{ row.Authorizes.Product_Presale ? (row.Authorizes.Product_Presale == 'ALL' ? '查看全部' : '指定部门') : '仅限本人' }}</el-descriptions-item>
          <el-descriptions-item label="项目报备限制">{{ row.Authorizes.Project_Enroll ? '查看全部' : '查看全部有效报备' }}</el-descriptions-item>
          <el-descriptions-item label="项目询价限制">{{ row.Authorizes.Project_Inquiry ? (row.Authorizes.Project_Inquiry == 'ALL' ? '查看全部' : '指定部门') : '仅限本人' }}</el-descriptions-item>
          <el-descriptions-item label="出库单限制" span="2">{{ row.Authorizes.Product_Outbound_Depts }} {{ row.Authorizes.Product_Outbound_Sales }}</el-descriptions-item>
          <el-descriptions-item label="政采云分析授权" span="2">{{ row.Authorizes.Trend_Region }} {{ row.Authorizes.Trend_Category }}</el-descriptions-item>
        </el-descriptions>
      </el-table-column>
      <el-table-column prop="Name" label="姓名" min-width="120" />
      <el-table-column prop="Account" label="登录名" min-width="120" />
      <el-table-column prop="Phone" label="手机号" min-width="120" />
      <el-table-column label="操作" width="150">
        <el-link slot="header" type="primary" icon="el-icon-plus" @click="openForm()">添加</el-link>
        <template slot-scope="{ row }">
          <el-link type="primary" icon="el-icon-edit" @click="openForm(row)">修改</el-link>
          <el-link type="danger" size="small" icon="el-icon-delete" @click="onDelete(row)">删除</el-link>
        </template>
      </el-table-column>
    </el-table>
    <div class="toolbar" slot="footer">
      <el-pagination background :page-size="datalist.PageSize" :current-page="datalist.PageIndex" :total="datalist.TotalCount" @current-change="onSearch" />
    </div>
  </full-container>
</template>

<script>
import form from "./form.vue"
export default {
  data () {
    return {
      loading: false,
      queryParams: { index: 1, size: 20 },
      datalist: {}
    }
  },
  created () {
    this.onSearch()
  },
  methods: {
    // 查询参数
    onSearch (val = 1) {
      this.queryParams.index = val
      this.loadData()
    },
    // 信息列表
    loadData () {
      if (this.loading) {
        return
      }
      this.loading = true
      this.$apis.organize.staff.list(this.queryParams).then((res) => {
        this.datalist = res
      }).catch((e) => {
        this.$message.error(e)
      }).finally(() => {
        this.loading = false
      })
    },
    //编辑
    openForm (row) {
      this.$layer.iframe({
        title: '用户授权',
        area: ['720px', 'auto'],
        content: {
          content: form,
          parent: this,
          data: {
            _detail: !row ? null : {
              DeptId: row.Dept.Id,
              UserId: row.Id,
              Name: row.Name,
              Account: row.Account,
              Phone: row.Phone,
              ...row.Authorizes
            }
          }
        }
      })
    },
    //删除
    onDelete (row) {
      this.$confirm('此操作将永久删除该数据, 是否继续?', `移除${row.Name}`, {
        center: true
      }).then(() => {
        this.$apis.organize.staff.delete({ id: row.Id }).then(() => {
          this.loadData()
          this.$message({ message: "数据提交成功！", type: "success" })
        }).catch((e) => {
          this.$message.error(e)
        }).finally(() => {
          this.loading = false
        })
      })
    }
  }
}
</script>
<style lang="scss" scoped>
:deep(.el-descriptions__body) {
  .el-descriptions-row:hover {
    background-color: unset !important;
  }
  .el-descriptions-item {
    border: unset !important;
    padding: 5px 10px;
    &__label {
      min-width: 80px;
      color: #99a9bf;
    }
  }
}
</style>